import {
  Profile,
  Address,
  UserSettings,
} from '@fantaz/shared/data-access/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PROFILE_FEATURE_KEY, ProfileState } from './profile.reducer';

// Lookup the 'Profile' feature state managed by NgRx
export const getProfileState =
  createFeatureSelector<ProfileState>(PROFILE_FEATURE_KEY);

export const getProfileLoaded = createSelector(
  getProfileState,
  (state: ProfileState) => state.loaded,
);

export const getProfileError = createSelector(
  getProfileState,
  (state: ProfileState) => state.error,
);

export const getProfile = createSelector(
  getProfileState,
  (state: ProfileState): Profile => state.data as Profile,
);

export const getShippingAddress = createSelector(
  getProfile,
  (profile: Profile): Address | undefined => profile?.shippingAddress,
);

export const isUpdating = createSelector(
  getProfileState,
  (state: ProfileState): boolean => state.updating,
);

export const getFormErrors = createSelector(
  getProfileState,
  (state: ProfileState) => state.formErrors,
);

export const isValidShippingAddress = createSelector(
  getProfile,
  (profile?: Profile): boolean => {
    if (profile && profile.shippingAddress)
      if (
        profile.firstName &&
        profile.lastName &&
        profile.phone &&
        profile.email &&
        profile.shippingAddress.addressLine1 &&
        profile.shippingAddress.city &&
        profile.shippingAddress.state &&
        profile.shippingAddress.zipCode &&
        profile.firstName !== '' &&
        profile.lastName !== '' &&
        profile.phone !== '' &&
        profile.email !== '' &&
        profile.shippingAddress.addressLine1 !== '' &&
        profile.shippingAddress.city !== '' &&
        profile.shippingAddress.state !== '' &&
        profile.shippingAddress.zipCode !== ''
      ) {
        return true;
      }

    return false;
  },
);
export const getProfileSettings = createSelector(
  getProfile,
  (profile?: Profile): UserSettings | null => {
    return profile?.userSettings || null;
  },
);
